export const propertyDamageActions = {
  handleClaimDescribedItems: ({ commit }: { commit: Function }, payload: string) => {
    commit("setClaimDescribedItems", payload);
  },
  handleClaimDamageDescription: ({ commit }: { commit: Function }, payload: string) => {
    commit("setClaimDamageDescription", payload);
  },
  handleClaimEstimatedDamage: ({ commit }: { commit: Function }, payload: number) => {
    commit("setClaimEstimatedDamage", payload);
  }
};
